import React, { Component } from "react";

import styled from "styled-components";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  InputGroup,
  Form,
  CardHeader,
} from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FormToFilterReport from "../../../../../components/forms/FormToFilterReport";
import CustomBarChart from "../../../../../components/Charts/barChart";
import DountChart from "../../../../../components/Charts/dountChart";
import Flatpickr from "react-flatpickr";
import CustomSplineArea from "../../../../../components/Charts/splineArea";
import { getCurrentDay, getSelectedMonthAgo } from "../../../../../helpers/utils";
import { getOffers } from "../../../../../store/offers/actions";

class MediaBuyerReports extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Media buyer stats</h5>
                  </Col>
                </Row>
                <CustomBarChart
                  data={this.props.mediaBuyerStats}
                  categories={["mediabuyer"]}
                  yaxisName="MediaBuyer Campaigns Stats"
                />
              </CardBody>
            </StyledCard>
          </Col>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Media buyer profit</h5>
                  </Col>
                </Row>
                <CustomBarChart
                  data={this.props.mediaBuyerProfit}
                  categories={["mediabuyer"]}
                  yaxisName="MediaBuyer Profit"
                  currency="$"
                />
              </CardBody>
            </StyledCard>
          </Col>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Media buyer campaigns spend</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.mediaBuyerSpend}
                  categories={["mediabuyer"]}
                  yaxisName="MediaBuyer Campaigns Spend"
                  typeChart="donut" // or pie
                  currency="$"
                />
              </CardBody>
            </StyledCard>
          </Col>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Campaigns count by media buyer</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.countByMediaBuyer}
                  categories={["mediabuyer"]}
                  yaxisName="MediaBuyer Campaigns Count"
                  typeChart="donut" // or pie
                  currency=""
                />
              </CardBody>
            </StyledCard>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const StyledCard = styled(Card)`
  border: 2px solid rgba(0, 0, 0, 0.05);
`;

MediaBuyerReports.propTypes = {
  mediaBuyerStats: PropTypes.any,
  mediaBuyerSpend: PropTypes.any,
  countByMediaBuyer: PropTypes.any,
  mediaBuyerProfit: PropTypes.any,
};

export default connect()(MediaBuyerReports);
